import * as React from 'react';
export const moneylionSvg = React.forwardRef(function moneylionSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00E5C4',
      d: 'M0 .097h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M28 16.097c0 1.4-.653 2.496-1.176 3.378-.196.333-.382.645-.49.903-.117.282-.214.65-.315 1.042-.258.983-.578 2.207-1.533 3.161-.956.957-2.178 1.276-3.165 1.533-.389.104-.757.2-1.04.317-.256.105-.568.291-.902.489-.883.523-1.98 1.177-3.379 1.177-1.397 0-2.496-.654-3.379-1.177-.332-.198-.644-.383-.902-.49-.281-.117-.65-.212-1.043-.316-.982-.258-2.206-.578-3.162-1.533-.954-.954-1.274-2.178-1.531-3.16-.103-.39-.198-.76-.317-1.043-.106-.257-.292-.57-.489-.902C4.653 18.593 4 17.495 4 16.098c0-1.4.653-2.496 1.177-3.38.198-.332.383-.644.489-.901.119-.282.215-.652.317-1.043.257-.984.578-2.208 1.531-3.162.956-.955 2.18-1.274 3.164-1.533.39-.103.758-.199 1.041-.316.258-.107.571-.292.902-.49.884-.523 1.982-1.176 3.379-1.176s2.497.653 3.379 1.177c.332.197.644.382.902.489.283.117.653.213 1.043.316.982.257 2.204.578 3.16 1.533.955.954 1.276 2.178 1.533 3.162.103.39.2.759.316 1.041.107.259.293.57.491.904.523.883 1.176 1.978 1.176 3.378Z',
      fill: '#000',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.777 12.036c.787-.045 1.58-.108 2.356.016.13.022.256.047.382.078.643.163 1.25.48 1.663.992.383.475.587 1.097 1.065 1.475.328.258.754.37 1.17.387.42.016.833-.053 1.245-.124.09-.014.184-.033.242-.102.07-.084.052-.21.02-.315-.25-.791-1.152-1.258-1.349-2.065-.034-.138-.03-.31.085-.39.093-.063.206-.037.321-.01.074.017.15.033.222.027.214-.02.356-.264.33-.478-.029-.215-.178-.394-.347-.53-.344-.28-.774-.43-1.204-.536-.85-.208-1.728-.262-2.604-.262-.11 0-.22 0-.331.002-1.813.025-3.627.222-5.388.649-.353.084-1.194.404-.68.865.126.111.29.164.45.204.765.19 1.563.161 2.35.117h.002Z',
      fill: '#6AE4C7',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M17.628 15.178a.312.312 0 0 0 .01-.11.884.884 0 0 0-.047-.206c-.116-.37-.251-.767-.568-.992-.272-.193-.625-.221-.959-.23h-.226c-.734 0-1.468.07-2.188.212-.446.088-.972.221-1.282.585-.276.324-.405.973-.109 1.323.153.178.389.257.615.32.776.213 1.585.335 2.386.256.8-.08 1.592-.373 2.192-.91a.552.552 0 0 0 .178-.246l-.002-.002Zm2.37 3.395c.297-.165.469-.412.453-.767a39.203 39.203 0 0 1-.018-.622c-.008-.357-.203-.575-.527-.69-.271-.096-.544-.19-.818-.28a1.324 1.324 0 0 0-1.026.077c-.373.182-.746.36-1.111.555a1.99 1.99 0 0 0-.412.307.526.526 0 0 0-.164.426c.004.12 0 .24 0 .353-.007.125-.011.244-.02.364-.01.16.045.3.174.385.131.086.278.158.43.204.346.106.7.197 1.055.28.153.036.315.049.475.05.223 0 .432-.067.629-.172.293-.155.592-.307.882-.469l-.002-.001Zm2.018.97a13.474 13.474 0 0 1-.423-.315.576.576 0 0 0-.364-.136.687.687 0 0 0-.325.089c-.377.202-.749.412-1.116.63a1.01 1.01 0 0 0-.483.605 57.41 57.41 0 0 0-.253.926c-.071.27.022.473.272.604s.495.27.748.396c.108.053.23.078.343.116a1.25 1.25 0 0 0 .467-.144c.267-.146.533-.295.798-.444a.912.912 0 0 0 .464-.675c.054-.32.103-.64.143-.96.035-.275-.03-.52-.27-.692h-.001Zm.655-3.518c-.043-.036-.095-.07-.15-.07h-.018a.239.239 0 0 0-.114.062c-.614.51-.651 1.64-.242 2.296.142.227.353.404.571.558.04.026.083.055.128.06a.247.247 0 0 0 .138-.029c.226-.105.368-.343.418-.586a1.27 1.27 0 0 0 .023-.185 2.729 2.729 0 0 0-.042-.561c-.089-.575-.251-1.191-.712-1.549v.004Z',
      fill: '#6AE4C7',
    }),
  );
});
moneylionSvg.defaultProps = {
  width: '32',
  height: '33',
  viewBox: '0 0 32 33',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var moneylion = {
  category: 'brand',
  colorable: false,
  name: 'moneylion',
  svg: moneylionSvg,
};
